import { Button, FloatingLabel, Form, Modal, ModalBody } from "react-bootstrap"
import { ButtonWithConfirmation, FeedbackButton } from "../../Commons/Functions"
import { useState } from "react"

export default function RenderTurnOrderModalContent(props) {
    if (!props.peerInstance.current) { return }

    function movePlayerInTurnOrder(index, direction) {
        let newIndex = index + direction
        if (newIndex < 0 || newIndex >= props.playerTurnOrder.length) { return }

        let tmpPlayerTurnOrder = [...props.playerTurnOrder]
        let tmp = tmpPlayerTurnOrder[index]
        tmpPlayerTurnOrder[index] = tmpPlayerTurnOrder[newIndex]
        tmpPlayerTurnOrder[newIndex] = tmp

        props.setPlayerTurnOrder(tmpPlayerTurnOrder)
        props.sendData({
            playerTurnOrder: tmpPlayerTurnOrder
        })
    }

    return (
        <>
            <h5>Turn order</h5>
            <div className='d-flex flex-column'>
                {props.playerTurnOrder.map((p, i) => {
                    const isPlayer = p === props.peerInstance.current.id
                    return (
                        <div className="d-flex" key={p}>
                            <div className='box-container w-100 justify-content-between' style={p == props.peerInstance.current.id ? { boxShadow: "0 0 0.15rem 0.15rem var(--main-color)" } : {}}>
                                <p className='d-flex align-items-center brighter px-3'>{i + 1}</p>
                                {isPlayer && (<p className='brighter d-flex align-items-center px-3 w-100'>{props.playerData.profileData.name}</p>)}
                                {!isPlayer && props.opponentsData[p] && (<p className='brighter d-flex align-items-center px-3 w-100'>{props.opponentsData[p].profileData.name}</p>)}
                                <div className='d-flex flex-row'>
                                    <Button onClick={() => movePlayerInTurnOrder(i, -1)} disabled={i == 0}>Up</Button>
                                    <Button onClick={() => movePlayerInTurnOrder(i, 1)} disabled={i == props.playerTurnOrder.length - 1}>Down</Button>
                                </div>
                            </div>
                            <div className="d-flex align-items-center" style={isPlayer ? { pointerEvents: 'none', visibility: 'hidden' } : {}}>
                                <ButtonWithConfirmation
                                    className="text-nowrap"
                                    onConfirm={() => props.disconnectWith(p)}>
                                    Kick player
                                </ButtonWithConfirmation>
                            </div>
                        </div>
                    )
                })}
            </div>
            {props.gameOptions && (<div className='d-flex flex-column'>
                <p className="mt-3 mb-1">End current player turn and become the active player.</p>
                <Button onClick={props.becomeActivePlayer}>Become active player</Button>
            </div>)}
        </>
    )
}